"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRadioLegend = exports.StyledRadioGroup = exports.StyledRadioContainer = exports.StyledRadioAlert = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alert = require("../../fuse-alert/src/alert");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledRadioGroup = exports.StyledRadioGroup = _styledComponents["default"].fieldset.attrs({
  className: 'fuse-radio-group'
}).withConfig({
  displayName: "styled-radio-group__StyledRadioGroup",
  componentId: "sc-1j1ht20-0"
})(["width:100%;"]);
var StyledRadioLegend = exports.StyledRadioLegend = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-radio-group__legend',
  'data-testid': 'fuse-radio-group__legend'
}).withConfig({
  displayName: "styled-radio-group__StyledRadioLegend",
  componentId: "sc-1j1ht20-1"
})(["margin-bottom:var(--spacing-global-space6);"]);
var StyledRadioAlert = exports.StyledRadioAlert = (0, _styledComponents["default"])(_alert.Alert).attrs({
  className: 'fuse-radio-group__alert',
  'data-testid': 'fuse-radio-group__alert'
}).withConfig({
  displayName: "styled-radio-group__StyledRadioAlert",
  componentId: "sc-1j1ht20-2"
})(["display:flex;margin-bottom:var(--spacing-global-space6);width:100%;@media only screen and (min-width:", "){width:fit-content;}"], _grid.gridConfig.m.minWidth);
var StyledRadioContainer = exports.StyledRadioContainer = _styledComponents["default"].div.attrs({
  className: 'fuse-radio-group__radio-container',
  'data-testid': 'fuse-radio-group__radio-container'
}).withConfig({
  displayName: "styled-radio-group__StyledRadioContainer",
  componentId: "sc-1j1ht20-3"
})(["", ""], function (_ref) {
  var stacked = _ref.stacked;
  return "\n\t\tdisplay: flex;\n\t\tflex-flow: ".concat(stacked ? 'column' : 'row', " wrap;\n\t\t\n\t\t& .fuse-radio {\n\t\t\tmargin-bottom: var(--spacing-global-space6);\n\t\t\tmargin-right: ").concat(stacked ? "0" : "var(--spacing-global-space6)", ";\n\t\t}\n\t");
});